<template>
  <div class="loading-screen">
    <div class="background-opacity"></div>
    <div class="loading-gif-container">
      <img class="loading-gif" :src="cx_loading_gif" loading="lazy"/>
    </div>
  </div>
</template>

<script>
import LoadingScreen from "@/components/Util/Loading/LoadingScreen/LoadingScreen";
export default LoadingScreen;
</script>

<style lang="scss">
@import "LoadingScreen.scss";
</style>
